import { JobData } from "./careers.model";
import { Component, OnInit, ViewChildren, QueryList, HostListener } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Urls } from "@root/utils/urls";
import { ApiService } from "@shared/services/api.service";
import { MatDialog } from "@angular/material/dialog";
import { ApplyJobDialogComponent } from "@component/careers/apply-job-dialog/apply-job-dialog.component";
import { SearchFilterPipe} from '@common/pipe/search-filter.pipe';
import {environment} from '../../../environments/environment.prod'
import { RedirectionService } from "@root/shared/services/redirection.service";
import { MatSelect } from '@angular/material/select';

@Component({
  selector: "app-careers",
  templateUrl: "./careers.component.html",
  styleUrls: ["./careers.component.scss"],
})
export class CareersComponent implements OnInit {
  
  jobData = new JobData();

  departmentList:any[] = [];

  locationList:any[] = [];

  @ViewChildren(MatSelect) selects!: QueryList<MatSelect>; 
  @HostListener('window:scroll') onWindowScroll() { this.selects.forEach(select => { if (select.panelOpen) { select.close(); } }); }

  postedJobList:any[] = [];

  panelMap: { [key: string]: boolean } = {};

  liveMessage = '';

  pageUrl!: string;

  public searchText!: string;

  searchSubmitted = false;

  constructor(
    public apiService: ApiService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private redirectionService : RedirectionService,
  ) {}

  ngOnInit() {
    this.scrollTop();
    this.readDepartment();
    this.readLocation();
    this.searchJob();
    this.pageUrl = location.href;
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  investOnline = () => {
    this.redirectionService.redirectToInvestorPortal();
      // if(!environment.isDRBuild){
      //   window.open("https://investonline.itiamc.com/", "_blank");
      // }else{
      //   window.open("https://investonline.itiamc.com/", "_blank"); //DR-inv
      // }
    };

  public readDepartment() {
    this.apiService.getData(Urls.getCareersDeparment).subscribe(
      (response) => {
        this.departmentList = response.data.departments;
      },
      (error) => {
        this.toastr.error(error.errorMessage);
      }
    );
  }

  public readLocation() {
    this.apiService.getData(Urls.getCareersLocation).subscribe(
      (response) => {
        this.locationList = response.data.locations;
      },
      (error) => {
        this.toastr.error(error.errorMessage);
      }
    );
  }

  // public searchJob() {
  //   const searchPipe = new SearchFilterPipe();
  //   this.apiService.postData(Urls.getCareersJOB, this.jobData).subscribe(
  //     (response) => {
  //       if (response.status === 0) {
  //         const postedJobList = response.data.careerJobs;
  //         this.postedJobList = searchPipe.transform(postedJobList, ['jobPostion', 'skills'], this.searchText) ;
  //       } else {
  //         this.postedJobList = [];
  //       }
  //     },
  //     (error) => {
  //       this.postedJobList = [];
  //     }
  //   );
  // }
  public searchJob() {
    this.searchSubmitted = true; if ( !this.searchText || !this.jobData.department || !this.jobData.location ) { return; }
  const searchPipe = new SearchFilterPipe();

  this.apiService.postData(Urls.getCareersJOB, this.jobData).subscribe(
    (response) => {
      if (response.status === 0) {
        const postedJobList = response.data.careerJobs;

        this.postedJobList =
          searchPipe.transform(
            postedJobList,
            ['jobPostion', 'skills'],
            this.searchText
          );

        this.liveMessage = '';

        setTimeout(() => {
          this.liveMessage =
            `${this.postedJobList.length} job openings found.`;
        }, 100);
      } else {
        this.postedJobList = [];

        this.liveMessage = '';

        setTimeout(() => {
          this.liveMessage =
            'No job openings found.';
        }, 100);
      }
    },
    () => {
      this.postedJobList = [];

      this.liveMessage = '';

      setTimeout(() => {
        this.liveMessage =
          'No job openings found.';
      }, 100);
    }
  );
}

  public openApplyJobDialog() {
    const dialogRef = this.dialog.open(ApplyJobDialogComponent,{
      width: "90%",
    });
  }

  keyPress(event: any) {
    const pattern = /[a-zA-Z ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onPanelOpened(job: any) {
  this.panelMap[job.id] = true;

  this.liveMessage = '';

  setTimeout(() => {
    this.liveMessage =
      `${job.jobPostion} expanded.`;
  }, 100);
}

onPanelClosed(job: any) {
  this.panelMap[job.id] = false;

  this.liveMessage = '';

  setTimeout(() => {
    this.liveMessage =
      `${job.jobPostion} collapsed.`;
  }, 100);
}
}
